import {SAVE_WINDOW_SCREEN} from '../../util/actionTypes';
import {getCredentialsFromCookie} from '../../util/helper';
const initialState ={};

const windowScreenReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case SAVE_WINDOW_SCREEN: 
            return {
                ...state,
                ...action.payload, 
              };     
  
        default:
            return state;
    }
};

export default windowScreenReducer;
